import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { asyncSimpleModal } from '../../lib/common';
import CategoryApi from '../../lib/api/category/CategoryApi';
import useToastMsg from '../common/useToastMsg';
import categoryToastMsg from '../../constants/service/toastMsg/categoryToastMsg';
import { CATEGORY } from '../../constants/queryKeys';

const useCategoryDelete = () => {
  const [selectedList, setSelectedList] = useState([]);
  const deleteCategoryList = useMutation({
    mutationFn: (data) => CategoryApi.deleteCategoryList(data),
  });

  const queryClient = useQueryClient();

  const { search = '' } = useLocation();
  const { success, error } = useToastMsg();

  const onDeleteCategoryList = async () => {
    if (selectedList.length > 100) {
      await asyncSimpleModal({
        type: 'error',
        title: '카테고리 삭제',
        message: '카테고리 삭제는 최대 100개 까지만 가능 합니다.',
      });

      return;
    }

    const confirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '카테고리 삭제',
      message: '선택 된 카테고리를 삭제 하시겠습니까?',
    });

    if (!confirmResult) return;

    deleteCategoryList.mutate(selectedList.toString(), {
      onSuccess: () => {
        // 카테고리 리스트 캐시 데이터 무효화
        queryClient.invalidateQueries([...CATEGORY.LIST, search]);
        // 선택된 카테고리 리스트 초기화
        setSelectedList([]);
        success(categoryToastMsg.DELETE_CATEGORY_LIST_REQUEST_SUCCESS);
      },
      onError: (err) => {
        console.error(err);
        error(categoryToastMsg.DELETE_CATEGORY_LIST_REQUEST_ERROR, err);
      },
    });
  };
  return { selectedList, onCheckCategoryItem: setSelectedList, onDeleteCategoryList };
};

export default useCategoryDelete;
